var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971",
    transform: "translate(-1059 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    transform: "translate(1059 95)",
    fill: "none",
    stroke: "#00d621",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 52,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 39.5,
    cy: 39.5,
    r: 39.5,
    transform: "translate(1072 108)",
    fill: "#00d621"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    transform: "translate(1067 103)",
    fill: "none",
    stroke: "#00d621",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 43.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-check-mark-lined",
    d: "M2.531,20.549,17.974,34.338a1.6,1.6,0,0,0,2.247-.125L44.077,7.657a1.592,1.592,0,1,0-2.371-2.126l-22.8,25.374L4.655,18.172a1.594,1.594,0,1,0-2.124,2.377",
    transform: "translate(1090 127.998)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.f97c6e31fe5f9fb18d1061905c147536.svg";
export { ForwardRef as ReactComponent };